
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","width":"31","height":"36","viewBox":"0 0 31 36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M25.754 17.939a.05.05 0 01-.03-.046.049.049 0 01.03-.045c4.096-2.1 4.832-6.748 2.7-8.288-2.363-1.7-5.266.294-5.855.7a.05.05 0 01-.077-.049c.995-6.208-4.643-11.444-11.431-9.169-7.938 2.674-4.909 12.48-4.383 14.055a.05.05 0 11-.084.056c-2.398-2.212-8.212.553-5.8 8.238 1.627 5.159 7.665 5.712 11.501 5.712h.66a41.155 41.155 0 00-.702 6.397h6.213a36.334 36.334 0 01-1.311-6.397h1.837c2.427 0 7.847-.434 10.253-3.913 3.646-5.285-.863-7.636-3.52-7.251z"}})])
          )
        }
      }
    